import { Button } from '@chakra-ui/button';
import { HStack } from '@chakra-ui/layout';
import { t } from '@lingui/macro';
import React from 'react';
import { useDispatch } from 'react-redux';

import { closeModal } from '../../../../../modal-manager';

type ModalFooterProps = {
    onClick: () => void
};

export function ModalFooter ({ onClick }: ModalFooterProps) {
    const dispatch = useDispatch();

    return (
        <HStack
            h={'72px'}
            justifyContent={'end'}
            alignSelf={'end'}
            pr={'44px'}
            background={'white'}
            width={'100%'}
            mb={0}
        >
            <Button
                data-testid={'promo-video-skip'}
                fontWeight={500}
                fontSize={'20px'}
                lineHeight={'21px'}
                onClick={() => {dispatch(closeModal());}}
                borderRadius={'31px'}
                color={'#007ACC'}
                border={'1px solid #99DDF6'}
                w={'160px'}
                backgroundColor={'white'}
            >
                {t`video.Modal.Button.Skip`}
            </Button>
            <Button
                variant={'primary'}
                data-testid={'promo-video-go'}
                fontWeight={500}
                fontSize={'20px'}
                lineHeight={'21px'}
                background={'linear-gradient(149deg, #00ABE8 4.33%, #007ACC 45.04%, #0063A7 100%)'}
                color={'white'}
                onClick={onClick}
                borderRadius={'31px'}
                w={'160px'}
                _hover={{ background: 'linear-gradient(149deg, #00ABE8 4.33%, #007ACC 45.04%, #0063A7 100%)' }}
            >
                {t`video.Modal.Button.WatchVideo`}
            </Button>
        </HStack>
    );
}
